import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import stylesTableDarkMode from '../styles/TableDarkMode'
import stylesTableLightMode from '../styles/TableLightMode'
import CategoriaItem from '../elementos/CategoriaItem';
import { motion, AnimatePresence } from "framer-motion";
import Modal from '../elementos/Modal';
import { FaArrowLeft } from 'react-icons/fa';

export default function Categorias({ data, onVolver }) {

    const { darkMode } = useDarkMode();

    const dynamicStyles = darkMode ? stylesTableDarkMode : stylesTableLightMode;

    const [activeIndex, setActiveIndex] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)
    const [itemSeleccionado, setItemSeleccionado] = useState()
    const [modalSoloNotas, setModalSoloNotas] = useState(false)

    const handleButtonClick = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    }

    const abrirModal = () => {
        setModalOpen(true)
    }

    const plusButtonBaseStyle = {
        flexShrink: 0,
        width: 22,
        height: 22,
        borderRadius: '6px',
        border: '1.5px solid rgba(151, 32, 52, 0.35)',
        backgroundColor: 'rgba(151, 32, 52, 0.07)',
        color: '#972034',
        fontSize: 15,
        fontWeight: '600',
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.15s ease, border-color 0.15s ease',
        padding: 0
    }

    const getDisabledButtonStyle = (isDisabled) => (
        isDisabled
            ? {
                opacity: 0.6,
                cursor: 'not-allowed',
                fontSize: 9,
                whiteSpace: 'normal',
                height: 34,
                minHeight: 34,
                overflow: 'hidden',
                lineHeight: 1.05,
                paddingTop: 4,
                paddingBottom: 4
            }
            : {}
    )

    const getDisabledLabelStyle = (isDisabled) => (
        isDisabled
            ? {
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                lineHeight: 1.15
            }
            : {}
    )

    return (
        <div className="mb-3">
            <div style={{ ...styles.headerRow, borderBottom: dynamicStyles.title.borderBottom }}>
                <h2 className="pb-1" style={{ ...dynamicStyles.title, ...styles.headerTitle, fontSize: '1.45rem' }}>Categorías</h2>
                <button
                    style={{
                        ...dynamicStyles.logoutButton,
                        ...styles.backButton
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = dynamicStyles.logoutButtonHover.backgroundColor}
                    onMouseOut={(e) => e.target.style.backgroundColor = dynamicStyles.logoutButton.backgroundColor}
                    onClick={onVolver}
                    aria-label="Volver"
                    title="Volver"
                >
                    <FaArrowLeft style={styles.backArrow} />
                </button>
            </div>
            <h3 className="pb-1" style={{ ...dynamicStyles.tituloCategoria, ...styles.sectionTitle }}>{data[0].indice_completo}. {data[0].categoria.nombre}</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ ...dynamicStyles.header, ...styles.compactHeader, width: '5%' }}>Índice</th>
                        <th style={{ ...dynamicStyles.header, ...styles.compactHeader, width: '82%' }}>Nombre</th>
                        <th style={{ ...dynamicStyles.header, ...styles.compactHeader, width: '13%', textAlign: 'center' }}>Agregar</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.values(Object.values(data)[0].hijos).map((item, index) => {
                        return (
                            item.tipo == "categoria" ?
                                <React.Fragment key={index}>
                                    {/* <tr key={index} style={{ ...index % 2 === 0 ? dynamicStyles.evenRow : dynamicStyles.oddRow, cursor: "pointer" }} onClick={() => handleButtonClick(index)}> */}
                                    <tr key={index} style={{ ...index % 2 === 0 ? dynamicStyles.evenRow : dynamicStyles.oddRow }}>
                                        <td style={{ ...dynamicStyles.cell, ...styles.compactCell, textAlign: 'center' }}>{item.indice_completo}</td>
                                        <td style={{ ...dynamicStyles.cell, ...styles.compactCell }}>{item.categoria.nombre}</td>
                                        <td style={{ ...dynamicStyles.cell, ...styles.compactCell, textAlign: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={() => handleButtonClick(index)}
                                                title="Abrir categoría"
                                                aria-label="Abrir categoría"
                                                style={{
                                                    ...plusButtonBaseStyle,
                                                    cursor: 'pointer'
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'rgba(151, 32, 52, 0.14)'
                                                    e.currentTarget.style.borderColor = 'rgba(151, 32, 52, 0.6)'
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'rgba(151, 32, 52, 0.07)'
                                                    e.currentTarget.style.borderColor = 'rgba(151, 32, 52, 0.35)'
                                                }}
                                            >
                                                +
                                            </button>
                                        </td>
                                    </tr>
                                    <AnimatePresence>
                                        {activeIndex === index && (
                                            <tr>
                                                <td colSpan="3"
                                                    style={{ ...index % 2 === 0 ? dynamicStyles.expandedEvenCell : dynamicStyles.expandedOddCell, ...styles.compactExpandedCell }}>
                                                    <motion.div
                                                        initial={{ height: 0, opacity: 0, rotateX: -90 }}
                                                        animate={{ height: "auto", opacity: 1, rotateX: 0 }}
                                                        exit={{ height: 0, opacity: 0, rotateX: -90 }}
                                                        transition={{ duration: 0.2 }}
                                                        style={{ overflow: "hidden", transformOrigin: "top", ...styles.compactExpandedContent }}
                                                    >
                                                        <CategoriaItem elem={item} />
                                                    </motion.div>
                                                </td>
                                            </tr>
                                        )}
                                    </AnimatePresence>
                                </React.Fragment>
                                :
                                item.tipo == "item" &&
                                <React.Fragment key={index}>
                                    <tr key={index} style={{ ...index % 2 === 0 ? dynamicStyles.evenRow : dynamicStyles.oddRow }} onClick={() => handleButtonClick(index)}>
                                        <td style={{ ...dynamicStyles.cell, ...styles.compactCell, textAlign: 'center' }}>{item.indice_completo}</td>
                                        <td style={{ ...dynamicStyles.cell, ...styles.compactCell }}>{item.item.nombre}</td>
                                        <td style={{ ...dynamicStyles.cell, ...styles.compactCell, textAlign: 'center' }}>
                                            {(() => {
                                                const isImportado = item.es_tipo_carga_por_importacion === true

                                                return (
                                                    <div style={styles.itemAccionesContainer}>
                                                        <button onClick={(e) => {
                                                            e.stopPropagation()
                                                            if (isImportado) return
                                                            setModalSoloNotas(false)
                                                            setItemSeleccionado(item)
                                                            abrirModal()
                                                        }}
                                                            disabled={isImportado}
                                                            title={isImportado ? 'Deshabilitado - Precarga Administrativa' : 'Agregar instancia'}
                                                            aria-label={isImportado ? 'Deshabilitado - Precarga Administrativa' : 'Agregar instancia'}
                                                            style={{
                                                                ...plusButtonBaseStyle,
                                                                cursor: isImportado ? 'not-allowed' : 'pointer',
                                                                opacity: isImportado ? 0.35 : 1
                                                            }}
                                                            onMouseOver={(e) => {
                                                                if (!isImportado) {
                                                                    e.currentTarget.style.backgroundColor = 'rgba(151, 32, 52, 0.14)'
                                                                    e.currentTarget.style.borderColor = 'rgba(151, 32, 52, 0.6)'
                                                                }
                                                            }}
                                                            onMouseOut={(e) => {
                                                                if (!isImportado) {
                                                                    e.currentTarget.style.backgroundColor = 'rgba(151, 32, 52, 0.07)'
                                                                    e.currentTarget.style.borderColor = 'rgba(151, 32, 52, 0.35)'
                                                                }
                                                            }}
                                                        >
                                                            +
                                                        </button>

                                                        {isImportado && (
                                                            <span
                                                                style={{
                                                                    ...styles.infoPrecargadaLabel,
                                                                    color: darkMode ? '#ffd8de' : '#7d1b29'
                                                                }}
                                                            >
                                                                Información Precargada
                                                            </span>
                                                        )}

                                                        {isImportado && (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    ...styles.verNotasButton,
                                                                    color: darkMode ? '#ffd8de' : '#7d1b29',
                                                                    borderColor: darkMode ? '#ffd8de' : '#7d1b29'
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    setModalSoloNotas(true)
                                                                    setItemSeleccionado(item)
                                                                    abrirModal()
                                                                }}
                                                            >
                                                                Ver notas
                                                            </button>
                                                        )}
                                                    </div>
                                                )
                                            })()}
                                        </td>
                                    </tr>
                                </React.Fragment>
                        )
                    })}
                </tbody>
            </table>
            {itemSeleccionado && (
                <Modal
                    elem={itemSeleccionado}
                    notas={itemSeleccionado?.notas ?? data?.[0]?.notas ?? null}
                    isOpen={modalOpen}
                    soloNotas={modalSoloNotas}
                    closeModal={() => {
                        setModalOpen(false)
                        setModalSoloNotas(false)
                    }}
                />
            )}
        </div>
    );
}

const styles = {
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        paddingBottom: '6px',
        marginBottom: '8px'
    },
    headerTitle: {
        marginBottom: 0,
        paddingBottom: 0,
        borderBottom: 'none',
        flex: 1
    },
    sectionTitle: {
        marginBottom: 8
    },
    compactHeader: {
        paddingTop: 4,
        paddingBottom: 4,
        fontSize: 13,
        lineHeight: 1.2
    },
    compactCell: {
        paddingTop: 4,
        paddingBottom: 4,
        fontSize: 13,
        lineHeight: 1.2
    },
    compactActionButton: {
        paddingTop: 5,
        paddingBottom: 5,
        fontSize: 12,
        lineHeight: 1.1
    },
    itemAccionesContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        flexWrap: 'nowrap'
    },
    verNotasButton: {
        border: '1px solid',
        background: 'transparent',
        fontSize: 12,
        fontWeight: 700,
        textDecoration: 'none',
        cursor: 'pointer',
        padding: '4px 8px',
        lineHeight: 1.2,
        borderRadius: 4,
        whiteSpace: 'nowrap'
    },
    infoPrecargadaLabel: {
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        whiteSpace: 'nowrap'
    },
    compactExpandedCell: {
        paddingTop: 4,
        paddingBottom: 4
    },
    compactExpandedContent: {
        fontSize: 13
    },
    backButton: {
        width: '60px',
        minWidth: '60px',
        padding: '8px 0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    backArrow: {
        fontSize: '18px',
        lineHeight: 1,
        color: '#ffffff',
        fontWeight: 700
    }
}